import { NgModule } from '@angular/core';

import { KeycloakAngularModule } from 'keycloak-angular';
import { KeycloakProvider } from './keycloak.provider';

@NgModule({
  declarations: [],
  imports: [KeycloakAngularModule],
  exports: [],
  providers: [KeycloakProvider],
})
export class KeycloakSetupModule {}
